const com20 = {
    length: { min: 16, max: 20 },
    payload: [
        { length: 1, name: "código", type: "bytes", description: "Código de configuración (1 byte).", pad: "00" },
        { length: 2, name: "istime", type: "bytes", description: "Empieza a medir desde istime (en minutos). istime = 0000 es medianoche", range: { min: 0, max: 1439 }, pad: "0000" },
        { length: 1, name: "isnum", type: "bytes", description: "Número de medidas tras el inicio", pad: "00" },
        { length: 2, name: "ismin", type: "bytes", description: "Medida cada ismin (en minutos)", range: { min: 1, max: 1439 }, pad: "0000" },
        { length: 2, name: "nope1", type: "bytes", description: "No se usa.", pad: "0000" },
    ],
};

export default com20;